import React from 'react';
import { useCurrentUserContext } from '../../../context/currentUser/CurrentUserContext';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GearIndex } from '../../../Model/GearIndex';
import { useGlobalizationContext } from '../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../context/globalization/useTranslation';
import { chevronDownIcon } from '@progress/kendo-svg-icons';

export const IndexDropdown: React.FC = () => {
  const { currentUser, selectedIndex, setSelectedIndex } = useCurrentUserContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <>
      {currentUser?.indexes && currentUser.indexes.length > 1 && (
        <DropDownList
          svgIcon={chevronDownIcon}
          title={selectedIndex?.displayName}
          label={translate('custom.toolbar.index')}
          data={currentUser.indexes}
          textField={'displayName'}
          dataItemKey="id"
          value={selectedIndex}
          fillMode="solid"
          onChange={(event: DropDownListChangeEvent) => {
            if (setSelectedIndex && event.value) {
              setSelectedIndex(event.value as GearIndex);
            }
          }}
        />
      )}
    </>
  );
};
